import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Core2Config } from '../shared';
import { CpCommerceFormAnswerLinkContainerModel } from '../../../../../models/aggregates/website-form/cpcommerce-form-answer-link-container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceFormAnswerLinkService extends BaseApiPublicLoginTemplateService<CpCommerceFormAnswerLinkContainerModel,CpCommerceFormAnswerLinkContainerModel,CpCommerceFormAnswerLinkContainerModel> {

  static readonly CP_COMMERCE_FORM_ANSWER_LINK_PATH = 'form-answer-links/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormAnswerLinkService.CP_COMMERCE_FORM_ANSWER_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormAnswerLinkService.CP_COMMERCE_FORM_ANSWER_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormAnswerLinkService.CP_COMMERCE_FORM_ANSWER_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormAnswerLinkService.CP_COMMERCE_FORM_ANSWER_LINK_PATH  + BaseApiTemplateService.PUBLIC_EP;
  }

  postPublic(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeaderJson(visa)
    );
  }

  updateReadStatusBackoffice(userSubmittedGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/update-read/' + userSubmittedGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl,
      {},
      this.getHttpHeaderJson(visa)
    );
  }
}

